<template>
	<div class="container"><slot /></div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
	.container {
		min-height: 100vh;
	}
</style>
